import styled, { css } from 'styled-components'
import { desktopBreakpoint, mobileBreakpoint, tabletBreakpoint } from 'react-components'

export const Container = styled.div(
    ({ theme }) => css`
        background: ${theme.colors.white};
        width: 100%;
        min-height: 3rem;

        border-bottom: ${theme.typography.border.width.xxxThin} ${theme.typography.border.style.solid}
            ${theme.colors.tfwBlackOpacity10};
        position: relative;

        @media only screen and (max-width: ${mobileBreakpoint.max}px) {
            border-bottom: 0;
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin-top: 0;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            width: 100vw;
            margin-left: calc(-50vw + 50%);
        }
    `,
)

export const InnerContainer = styled.div`
    max-width: 83rem;
    margin: 0 auto;
    padding: 0.5rem 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0.5rem 1.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0.5rem 4rem;
    }
`

export const TrustItemsContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.medium};
        align-items: center;
        justify-content: center;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;
            gap: ${theme.spacing.medium};
        }
    `,
)

export const TrustItem = styled.div<{ $isTrustPilotLogo?: boolean }>(
    ({ theme, $isTrustPilotLogo }) => css`
        display: flex;
        align-items: center;
        gap: ${$isTrustPilotLogo ? '0' : theme.spacing.small};
        flex: ${$isTrustPilotLogo ? '0 0 auto' : '1'};
        justify-content: center;

        @media only screen and (max-width: ${mobileBreakpoint.max}px) {
            display: ${$isTrustPilotLogo ? 'flex' : 'none'};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            gap: ${$isTrustPilotLogo ? '0' : theme.spacing.medium};
        }
    `,
)

export const IconWrapper = styled.div<{ $isTrustPilotLogo?: boolean }>(
    ({ $isTrustPilotLogo }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${$isTrustPilotLogo ? '7rem' : '1.5rem'};
        height: ${$isTrustPilotLogo ? '3.5rem' : '1.5rem'};
        flex-shrink: 0;

        svg {
            width: 80%;
            height: ${$isTrustPilotLogo ? '60%' : '100%'};
            object-fit: contain;
        }

        ${$isTrustPilotLogo &&
        css`
            @media only screen and (min-width: ${desktopBreakpoint.min}px) {
                margin-right: 3.75rem;
            }
        `}

        img {
            height: 1.5rem !important;
            min-height: unset !important;

            @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                height: 2.5rem !important;
            }

            @media only screen and (min-width: ${desktopBreakpoint.min}px) {
                height: 2.5rem !important;
            }
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            width: ${$isTrustPilotLogo ? '5.45rem' : '1.5rem'};
            height: ${$isTrustPilotLogo ? '2.44rem' : '1.5rem'};
        }

        @media only screen and (max-width: 767px) and (min-width: 554px) {
            height: 2.25rem !important;

            img,
            svg {
                width: 100% !important;
                height: 100% !important;
                object-fit: contain !important;
            }
        }
    `,
)

export const DesktopIconWrapper = styled(IconWrapper)`
    display: none;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        display: flex;
    }
`

export const MobileIconWrapper = styled(IconWrapper)`
    display: flex;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        display: none;
    }
`

export const TextContent = styled.div(
    () => css`
        display: flex;
        flex-direction: column;
        gap: 0.125rem;
        text-align: center;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            text-align: left;
        }
    `,
)

export const Label = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-weight: ${theme.typography.font.weight.normal};
        font-size: 0.875rem;
        line-height: 1.125rem;
        color: ${theme.colors.tfwBlack87};
        word-spacing: 0.1em;
        letter-spacing: 0.01em;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 0.8125rem;
            line-height: 1rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            line-height: 1.375rem;
        }
    `,
)
